(() => {
  const selector = 'quick-order-list';
  const source = document.documentElement.dataset.dtQuickOrderListUrl;
  if (!source || customElements.get(selector)) return;

  let requested = false;
  let observer;

  const load = () => {
    if (requested || customElements.get(selector)) return;
    requested = true;
    observer?.disconnect();

    const absoluteSource = new URL(source, window.location.href).href;
    const existingScript = [...document.scripts].find((script) => script.src === absoluteSource);
    if (existingScript) return;

    const script = document.createElement('script');
    script.src = absoluteSource;
    script.async = true;
    script.dataset.dtQuickOrderListLoader = 'true';
    document.head.appendChild(script);
  };

  const containsComponent = (node) =>
    node instanceof Element && (node.matches(selector) || Boolean(node.querySelector(selector)));

  if (document.querySelector(selector)) {
    load();
    return;
  }

  observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some(containsComponent))) load();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
